// Module
var code = "<h1 id=logo-徽标>Logo 徽标</h1> <p>GLP 通用徽标。</p> <p>GLP后台系统统一系统徽标，用于菜单栏logo。</p> ";
// Exports
module.exports = code;